<template>
  <div :class="classes" @click="$emit('select', person.personId)">
    <ovp-person-name class="tabs-tab__name" :person="person" />
  </div>
</template>

<script>
import OvpPersonName from '@/components/Person/Name'

export default {
  name: 'Tab',

  components: {
    OvpPersonName,
  },

  props: {
    person: {
      type: Object,
      required: true,
    },

    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        tab: true,
        'tab--active': this.selected,
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.tab {
  min-width: 40px;
  max-width: 200px;
  cursor: pointer;
  padding: 15px;
  height: 50px;
  line-height: 20px;

  background-color: var(--c-light-gray);

  &--active {
    background-color: var(--c-white);
  }

  &__name {
    width: 100%;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .tab {
    height: initial;
    padding: 10px;
  }
}
</style>
